import Image from "next/image";
import Link from "next/link";
import CookieSettingsLink from "@/components/Footer/CookieSettingsLink";

export function ReputechFooter() {
  return (
    <footer className="bg-[#102c2b] text-white">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-8 px-5 py-10 sm:px-6 md:flex-row md:items-end md:justify-between">
        <div className="flex flex-col gap-4">
          <Link aria-label="Reputech home" className="w-fit" href="/">
            <Image alt="Reputech" height={34} src="/brand/logo-white.svg" width={164} />
          </Link>
          <a className="text-sm text-white/75 hover:text-white" href="mailto:support@reputech.io">
            support@reputech.io
          </a>
        </div>
        <nav aria-label="Legal links" className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-white/75">
          <Link className="hover:text-white" href="/imprint">Imprint</Link>
          <Link className="hover:text-white" href="/terms">Terms of Service</Link>
          <Link className="hover:text-white" href="/privacy">Privacy Policy</Link>
          <CookieSettingsLink label="Cookie settings" />
        </nav>
        <p className="text-xs text-white/50 md:text-right">© {new Date().getFullYear()} Reputech</p>
      </div>
    </footer>
  );
}
